// @flow
import { cookie } from '@nats/webclient-common';

export const getApiOptions = () => ({
  withCredentials: false,
  headers: {
    Authorization: cookie.getCookie(cookie.COOKIE.ID_TOKEN),
  },
});
